import { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { FaChevronLeft, FaChevronRight } from 'react-icons/fa';
import CC1 from "../assets/images/contacto/CC1.png"
import CC2 from "../assets/images/contacto/CC2.png"
import CC3 from "../assets/images/contacto/CC3.png"

const images = [CC1,CC2,CC3];

function CarouselContacto() {
  const [current, setCurrent] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      nextSlide();
    }, 5000);
    return () => clearInterval(interval);
  }, [current]);

  const nextSlide = () => {
    setCurrent((prev) => (prev + 1) % images.length);
  };

  const prevSlide = () => {
    setCurrent((prev) => (prev - 1 + images.length) % images.length);
  };

  return (
    <div className="relative w-full h-[75vh] overflow-hidden rounded-2xl shadow-2xl bg-gris-claro">
      <AnimatePresence mode="wait">
        {images.map((img, index) => (
          index === current && (
            <motion.div
              key={img}
              initial={{ opacity: 0, x: 50 }}
              animate={{ opacity: 1, x: 0 }}
              exit={{ opacity: 0, x: -50 }}
              transition={{ duration: 1.2, ease: 'easeInOut' }}
              className="absolute inset-0 w-full h-full"
            >
              <img
                src={img}
                alt={`Slide ${index + 1}`}
                className="w-full h-full object-cover rounded-2xl"
                loading="lazy"
              />
            </motion.div>
          )
        ))}
      </AnimatePresence>

      {/* Navigation buttons */}
      <button
        className="absolute top-1/2 left-4 transform -translate-y-1/2 bg-azul-oscuro bg-opacity-70 text-blanco p-3 rounded-full hover:bg-opacity-90 transition-all"
        onClick={prevSlide}
      >
        <FaChevronLeft size={28} />
      </button>
      <button
        className="absolute top-1/2 right-4 transform -translate-y-1/2 bg-azul-oscuro bg-opacity-70 text-blanco p-3 rounded-full hover:bg-opacity-90 transition-all"
        onClick={nextSlide}
      >
        <FaChevronRight size={28} />
      </button>

      {/* Indicators */}
      <div className="absolute bottom-6 left-1/2 transform -translate-x-1/2 flex space-x-3">
        {images.map((_, index) => (
          <div
            key={index}
            className={`h-4 w-4 rounded-full ${index === current ? 'bg-oro scale-125' : 'bg-gris-oscuro'} transition-all duration-700`}
          />
        ))}
      </div>
    </div>
  );
}

export default  CarouselContacto;
